/**
 * Route paths for the economy pod.
 *
 * Deliberately kept free of imports: components inside the pod read these at module
 * scope, so pulling them from `economy.router` would create an import cycle through
 * the route and component barrels.
 */
export const EconomyPaths = {
  Home: '/economy',
  Summary: '/economy/summary',
  BudgetStatus: '/economy/budget-status',
  Operations: '/economy/operations',
  Settlement: '/economy/settlement',
  CompanyCosts: '/economy/company-costs',
  Settings: '/economy/settings',
};
